import { AxiosError } from "axios";
import InterruptTransferStation from "../components/result/InterruptTransferStation/InterruptTransferStation";
import { TaxiStandInfo } from "../lib/TaxiStand/data/AirportTaxiMaster";
import { TraininfoList } from "../services/ekispert/models";
import { TaxiCompanyConfigurations } from "../services/taxi/GetTaxiMetaInfo/model/taxiCompanyConf";
import { GeneralTmpValues } from "../states/general";
import { UniversalMaaSQuery } from "../states/universalMaaSQuery";

// 探索条件に関わるアクション。

export enum GeneralActionType {
  SWITCH_IS_FAIL_IN_GET_COURSES = 'SWITCH_IS_FAIL_IN_GET_COURSES',
  SWITCH_SHOW_MAP = 'SWITCH_SHOW_MAP',
  SWITCH_CANDIDATE_SELECTOR_IS_VIA = 'SWITCH_CANDIDATE_SELECTOR_IS_VIA',
  SWITCH_SHOW_CANDIDATE_LIST_MODAL = 'SWITCH_SHOW_CANDIDATE_LIST_MODAL',
  SWITCH_IS_FROM_MAP_TO_CANDIDATE_LIST_MODAL = 'SWITCH_IS_FROM_MAP_TO_CANDIDATE_LIST_MODAL',
  SWITCH_IS_LOADING = 'SWITCH_IS_LOADING',
  SWITCH_IS_INITIAL = 'SWITCH_IS_INITIAL',
  SWITCH_IS_FAIL_ASSIGN_DIA = 'SWITCH_IS_FAIL_ASSIGN_DIA',
  UPDATE_ERROR_MESSAGE = 'UPDATE_ERROR_MESSAGE',
  UPDATE_REFERRER = 'UPDATE_REFERRER',
  UPDATE_TRAININFO = 'UPDATE_TRAININFO',
  UPDATE_AXIOS_ERROR = 'UPDATE_AXIOS_ERROR',
  UPDATE_PUBLIC_LANG = 'UPDATE_PUBLIC_LANG',
  UPDATE_TMP_VALUES = 'UPDATE_TMP_VALUES',
  UPDATE_TMP_IS_UPDATE_IN_MAP_SELECTOR = 'UPDATE_TMP_IS_UPDATE_IN_MAP_SELECTOR',
  UPDATE_TAXI_COMPANY_CONFIGURATIONS = 'UPDATE_TAXI_COMPANY_CONFIGURATIONS',
  UPDATE_UNIVERSAL_MAAS_QUERY = "UPDATE_UNIVERSAL_MAAS_QUERY",
  UPDATE_TAXI_STAND_INFO = "UPDATE_TAXI_STAND_INFO",
  UPDATE_INTERRUPT_TRANSFER_STATIONS = "UPDATE_INTERRUPT_TRANSFER_STATIONS",
  UPDATE_INTERRUPT_TRANSFER_STATIONS_IN_UNDECIDED = "UPDATE_INTERRUPT_TRANSFER_STATIONS_IN_UNDECIDED",
  SWITCH_IS_BACKEND_CROWDED_SEARCH = 'SWITCH_IS_BACKEND_CROWDED_SEARCH',
  SWITCH_IS_BACKEND_CROWDED_GET_FLIGHT_INFO = 'SWITCH_IS_BACKEND_CROWDED_GET_FLIGHT_INFO',
  SWITCH_IS_BACKEND_CROWDED_SEARCH_DIA_LIST = 'SWITCH_IS_BACKEND_CROWDED_SEARCH_DIA_LIST',
  SWITCH_MODE = 'SWICH_MODE',
  SWITCH_USE_V2 = 'SWITCH_USE_V2',
  RANDOM_TMP_AD_ROATATION_VALUE = 'RANDOM_TMP_AD_ROATATION_VALUE'
}

export interface GeneralAction {
  payload: any;
  type: GeneralActionType;
  modeType?: string;
  isOutbound?: boolean;
}

export const switchIsFailInGetCourses = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_IS_FAIL_IN_GET_COURSES,
})

export const switchShowMap = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_SHOW_MAP,
})

export const switchCandidateSelectorIsVia = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_CANDIDATE_SELECTOR_IS_VIA,
})

export const switchShowCandidateListModal = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_SHOW_CANDIDATE_LIST_MODAL,
})

export const switchIsFromMapToCandidateListModal = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_IS_FROM_MAP_TO_CANDIDATE_LIST_MODAL,
})

export const switchisLoading = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_IS_LOADING,
})

export const switchIsInitial = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_IS_INITIAL,
})

export const switchIsErrorAssignDia = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_IS_FAIL_ASSIGN_DIA,
})

export const updateErrorMessage = (v: string) => ({
  payload: v,
  type: GeneralActionType.UPDATE_ERROR_MESSAGE,
})

export const updateReferrer = (v: string) => ({
  payload: v,
  type: GeneralActionType.UPDATE_REFERRER,
});

export const updateTraininfo = (v: TraininfoList) => ({
  payload: v,
  type: GeneralActionType.UPDATE_TRAININFO,
})

export const updateAxiosError = (v: AxiosError) => ({
  payload: v,
  type: GeneralActionType.UPDATE_AXIOS_ERROR,
})

export const updatePublicLang = (v: string) => ({
  payload: v,
  type: GeneralActionType.UPDATE_PUBLIC_LANG,
})

export const updateTmpValues = (v: GeneralTmpValues) => ({
  payload: v,
  type: GeneralActionType.UPDATE_TMP_VALUES,
})

export const updateInterruptTransferStations = (v: InterruptTransferStation[], isOutbound: boolean = true) => ({
  payload: v,
  type: GeneralActionType.UPDATE_INTERRUPT_TRANSFER_STATIONS,
  isOutbound: isOutbound
})

export const updateInterruptTransferStationsInUndecided = (v: InterruptTransferStation[], isOutbound: boolean = true) => ({
  payload: v,
  type: GeneralActionType.UPDATE_INTERRUPT_TRANSFER_STATIONS_IN_UNDECIDED,
  isOutbound: isOutbound
})

export const switchIsBackendCrowdedSearch = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_IS_BACKEND_CROWDED_SEARCH,
})

export const switchIsBackendCrowdedFlightInfo = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_IS_BACKEND_CROWDED_GET_FLIGHT_INFO,
})

export const switchIsBackendSearchDiaList = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_IS_BACKEND_CROWDED_SEARCH_DIA_LIST,
})

export const updateTmpIsUpdateInMapSelector = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.UPDATE_TMP_IS_UPDATE_IN_MAP_SELECTOR,
})

export const updateTaxiCompanyConfigurations = (v: TaxiCompanyConfigurations) => ({
  payload: v,
  type: GeneralActionType.UPDATE_TAXI_COMPANY_CONFIGURATIONS,
});

export const updateUniversalMaaSQuery = (v: UniversalMaaSQuery) => ({
  payload: v,
  type: GeneralActionType.UPDATE_UNIVERSAL_MAAS_QUERY,
});

export const updateTaxiStandInfo = (v: TaxiStandInfo) => ({
  payload: v,
  type: GeneralActionType.UPDATE_TAXI_STAND_INFO,
})

export const switchGeneralMode = (v: boolean, modeType: string) => ({
  payload: v,
  type: GeneralActionType.SWITCH_MODE,
  modeType: modeType
})

export const randomTmpAdRoatationValue = () => ({
  payload: Math.floor(Math.random() * Math.pow(10,10)),
  type: GeneralActionType.RANDOM_TMP_AD_ROATATION_VALUE,
})

export const switchUseV2 = (v: boolean) => ({
  payload: v,
  type: GeneralActionType.SWITCH_USE_V2,
})
